// extracted by mini-css-extract-plugin
export default {"divider":"WordPractice_divider__BQqZK","wordsContainer":"WordPractice_wordsContainer__rTaIQ","word":"WordPractice_word__nlntp"};